var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('a',{staticClass:"dropdown-item text-danger",attrs:{"href":"/logout"}},[_c('i',{staticClass:"nc-icon nc-button-power"}),_vm._v(" Cerrar sesión ")])])
}]

export { render, staticRenderFns }